import { createSelector } from 'reselect';

export const selectProgress = (state) => state.get('progress');

export const selectPendingRequests = (state) =>
  selectProgress(state).get('pendingRequests');

export const makeSelectPendingRequests = () =>
  createSelector(selectPendingRequests, (pendingRequests) => pendingRequests);
